export default __webpack_public_path__ + "static/media/1.707f053d.jpg";